var _path, _mask, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28891 2.375H10.4956C10.4956 2.375 10.8689 3.035 9.90224 3.44167V7.36167C9.90224 7.36167 11.3156 7.835 11.3756 8.92833H4.62891C4.62891 8.92833 4.90891 7.76833 5.97557 7.36167V3.44167C5.97557 3.44167 5.09557 3.12833 5.28224 2.375H5.28891Z",
    stroke: "#C0C0C0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_4982_81371",
    maskUnits: "userSpaceOnUse",
    x: 6.59375,
    y: 9.07812,
    width: 2,
    height: 6,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 6.59375,
    y: 9.07812,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40708 9.07812V12.7315C8.40708 12.9581 8.22708 13.9515 8.00042 13.9515C7.77375 13.9515 7.59375 12.9581 7.59375 12.7315V9.07812"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40708 9.07812V12.7315C8.40708 12.9581 8.22708 13.9515 8.00042 13.9515C7.77375 13.9515 7.59375 12.9581 7.59375 12.7315V9.07812",
    fill: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27375 9.07812V12.7315H8.54042V9.07812H8.27375ZM8.27375 12.7315C8.27375 12.8282 8.23192 13.1205 8.15987 13.3923C8.12408 13.5273 8.08313 13.6482 8.04053 13.7327C8.01902 13.7753 8.00047 13.8018 7.98698 13.8158C7.97259 13.8307 7.97742 13.8181 8.00042 13.8181V14.0848C8.08008 14.0848 8.14012 14.0412 8.17895 14.0009C8.2187 13.9597 8.2514 13.9068 8.27863 13.8527C8.33354 13.7439 8.38008 13.6023 8.41763 13.4606C8.49225 13.1791 8.54042 12.8614 8.54042 12.7315H8.27375ZM8.00042 13.8181C8.02341 13.8181 8.02824 13.8307 8.01385 13.8158C8.00037 13.8018 7.98181 13.7753 7.9603 13.7327C7.9177 13.6482 7.87675 13.5273 7.84097 13.3923C7.76892 13.1205 7.72708 12.8282 7.72708 12.7315H7.46042C7.46042 12.8614 7.50858 13.1791 7.5832 13.4606C7.62075 13.6023 7.6673 13.7439 7.7222 13.8527C7.74943 13.9068 7.78213 13.9597 7.82188 14.0009C7.86072 14.0412 7.92075 14.0848 8.00042 14.0848V13.8181ZM7.72708 12.7315V9.07812H7.46042V12.7315H7.72708Z",
    fill: "#C0C0C0",
    mask: "url(#path-2-outside-1_4982_81371)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.7ee479d147c6dc817a45fffe1361b519.svg";
export { ForwardRef as ReactComponent };